export default "__VITE_ASSET__C$YN6B7X__"